import { createApiCall } from 'lib/base';

const GET_INVESTCORE_EMPLOYEE_PROGRAM_ESTIMATE_API_ID =
  'DASHBOARD/GET_INVESTCORE_EMPLOYEE_PROGRAM_ESTIMATE_API_ID';

const apiCall = createApiCall(
  GET_INVESTCORE_EMPLOYEE_PROGRAM_ESTIMATE_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employee-programs/${id}/estimate-vesting`,
    method: 'GET',
    isStay: true,
  })
);

export default apiCall;
